<template>
<div class="chapter">
<div class="inner_page">
<div class="dedicationPage" id="ded">
<a id="page06">
<p class="dedicationText">To my wonderful Steeple Hill editors<br/> Melissa Endlich, Emily Rodmell and Tina James.<br/> Thank you for your encouragement and wisdom.<br/> To my beloved grandchildren Tyler, Drew,<br/> Lauren and Carter. God bless you for giving me<br/> fresh eyes, endless joy and hope for the future.<br/> To the Daves, our sons by marriage, and my<br/> husband, Dale—your steadfast faith is a<br/> role model for our family.</p>
</a></div>
<a id="page06">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// substitutebridethe_ded.vue?6f69400e